import { MeterVerificationStateService } from '@account/login/meterVerificationState.service';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { XmlHttpRequestHelper } from '@shared/helpers/XmlHttpRequestHelper';
import { LocalStorageService } from '@shared/utils/local-storage.service';

@Injectable()
export class AppAuthService {
    logout(reload?: boolean, returnUrl?: string): void {
        var _localStorageService = new LocalStorageService();
        let token = abp.auth.getToken(); //this will not work with httpOnly cookie
        if (!token || token == '') {
            _localStorageService.getItem('Abp.AuthToken', function (err, value) {
                token = value?.token;
            });
        }

        let customHeaders = {
            [abp.multiTenancy.tenantIdCookieName]: abp.multiTenancy.getTenantIdCookie(),
            Authorization: 'Bearer ' + token,
        };

        XmlHttpRequestHelper.ajax(
            'GET',
            AppConsts.remoteServiceBaseUrl + '/api/TokenAuth/LogOut',
            customHeaders,
            null,
            () => {
                abp.auth.clearToken(); //this will not work with httpOnly
                abp.auth.clearRefreshToken(); //this will not work with httpOnly cookie

                _localStorageService.removeItem('Abp.AuthToken'); //remove token that was set on login.service.ts
                _localStorageService.removeItem('Abp.Localization.CultureName');

                // Clear localization cookies
                abp.utils.deleteCookie('Abp.Localization.CultureName', abp.appPath);
                abp.utils.deleteCookie('.AspNetCore.Culture', abp.appPath);

                // MeterVerificationStateService.clear();
                localStorage.removeItem('isMetersVerified');

                _localStorageService.removeItem(AppConsts.authorization.encrptedAuthTokenName, () => {
                    if (reload !== false) {
                        if (returnUrl) {
                            location.href = returnUrl;
                        } else {
                            location.href = '';
                        }
                    }
                });
            },
            false
        );
    }
}
